export default __webpack_public_path__ + "static/headerMobile@2x-608b8a0b321f8ebfc356c9732cdbfb9e.png";